// extracted by mini-css-extract-plugin
module.exports = {"tag":"YearsTag-module__tag"};